const RELOAD_KEY = 'chunkLoadErrorReloadedAt';
const RELOAD_INTERVAL_MS = 60 * 1000;
const CHUNK_ERROR_PATTERN = /loading (css )?chunk [\w-]+ failed/i;

interface IReloadOnChunkLoadErrorDependencies {
  storage?: Pick<Storage, 'getItem' | 'setItem'>;
  reload?: () => void;
  now?: () => number;
}

export function isChunkLoadError(error: unknown) {
  if (!(error instanceof Error)) return false;

  return (
    error.name === 'ChunkLoadError' || CHUNK_ERROR_PATTERN.test(error.message)
  );
}

/**
 * Após um deploy os chunks antigos deixam de existir e quem estava com a
 * página aberta passa a receber o index.html no lugar deles. Recarrega uma
 * vez para buscar a versão nova; se o erro voltar logo depois, deixa a falha
 * seguir para a tela de erro em vez de entrar em loop (ED-7438).
 */
export default function reloadOnChunkLoadError(
  error: unknown,
  {
    storage: injectedStorage,
    reload = () => window.location.reload(),
    now = Date.now,
  }: IReloadOnChunkLoadErrorDependencies = {},
) {
  if (!isChunkLoadError(error)) return false;

  try {
    const storage = injectedStorage ?? window.sessionStorage;
    const lastReload = Number(storage.getItem(RELOAD_KEY));

    if (lastReload && now() - lastReload < RELOAD_INTERVAL_MS) return false;

    storage.setItem(RELOAD_KEY, String(now()));
  } catch {
    return false;
  }

  reload();

  return true;
}
